import React, { useCallback, useEffect, useMemo, useState } from "react";
import { TRAINING_STATUS_VIEW } from "app/_pages/_healthSafetyEnvironment/TrainingManagement/CONSTANTS";
import { TRAINING_TYPE_VIEW } from "app/_pages/_healthSafetyEnvironment/TrainingManagement/CONSTANTS";
import { Modal, Button, Accordion, Card } from "react-bootstrap";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import { MEDICAL_STATUS_VIEW } from "app/_pages/_healthSafetyEnvironment/Medical/Constant";
import { MEDICAL_TYPE_VIEW } from "app/_pages/_healthSafetyEnvironment/Medical/Constant";
import { capaStatuses } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/CONSTANTS";
import FilesExport from "app/Components/CommanComponents/FilesExport";
import { EMPLOYEE_MEDICAL_CATEGORY } from "../Constant";
import { VFL_STATUS_VIEW } from "app/_pages/_healthSafetyEnvironment/VFL/CONSTANTS";
import { TASK_STATUS_VIEW } from "app/_pages/_healthSafetyEnvironment/EHSAuditsMeetings/CONSTANT";
import { MdKeyboardArrowDown, MdKeyboardArrowRight } from "react-icons/md";
import { userDropdownLabel } from "app/_helpers/helper";

function ConfirmationModal({
  confirmation,
  onHideConfirmation,
  confirmMsg,
  confirmationAlert,
  title,
  checkMedicalForPending,
  modalFor,
  type,
}) {
  let isMedicalPending =
    confirmMsg.pendingMedicalSchedule?.length && checkMedicalForPending;
  return (
    <>
      <Modal
        size="lg"
        show={confirmation}
        onHide={onHideConfirmation}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header>
          <Modal.Title>
            <h4> {`${title}`}</h4>
          </Modal.Title>
          <FilesExport id="#mainConfirmationBox" hideImgBtn pendingRecordPopup />
        </Modal.Header>
        <Modal.Body>
          <ConfirmationModalBody
            confirmMsg={confirmMsg}
            modalFor={modalFor}
            type={type}
            isMedicalPending={isMedicalPending}
            // className="confirmBox"
          />
          {!isMedicalPending ? (
            <div className="bttm-text">
              <span>{`Do you want to continue with ${
                type !== "location" ? modalFor + " status" : "location"
              } update?`}</span>
            </div>
          ) : (
            ""
          )}
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <div>
            {(!confirmMsg.pendingMedicalSchedule?.length || !checkMedicalForPending) && (
              <Button
                onClick={() => {
                  confirmationAlert();
                }}
                variant="primary"
              >
                Yes
              </Button>
            )}
            <Button
              className="ml-2"
              variant="secondary"
              onClick={() => onHideConfirmation()}
            >
              {isMedicalPending ? "Ok" : "No"}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {confirmation ? (
        <ConfirmationModalBody
          confirmMsg={confirmMsg}
          modalFor={modalFor}
          type={type}
          isMedicalPending={isMedicalPending}
          id="mainConfirmationBox"
        />
      ) : (
        ""
      )}
    </>
  );
}

export default ConfirmationModal;

export const ConfirmationModalBody = ({
  confirmMsg,
  className,
  id,
  modalFor,
  type,
  isMedicalPending,
}) => {
  const [panelIndex, setPanelIndex] = useState(0);
  const customOnClick = (eventKey) => {
    setPanelIndex(eventKey === panelIndex ? null : eventKey);
  };

  return (
    <div className={className || ""} id={id || ""}>
      {!isMedicalPending ? (
        <>
          <div className="mb-4 fs-3">
            {type === "location" ? (
              <div style={{ fontSize: "17px" }}>
                <p>
                  The following action items are currently under process in various
                  modules. If you continue with location update, then the following
                  workflows will be reverted to respective workflow owners for an
                  alternate assignment of pending activities.
                </p>
              </div>
            ) : (
              <div style={{ fontSize: "17px" }}>
                The following action items are currently under process in various modules.
                If you continue with {modalFor} status update, then the following
                workflows will be reverted to respective workflow owners for an alternate
                assignment of pending activities.
              </div>
            )}
          </div>
          <h4 className="outstandingTxt">
            <strong>List of Outstanding Workflows under respective modules:</strong>
          </h4>
          <Accordion defaultActiveKey={"0"} className="incidentDetailAcc">
            {confirmMsg?.pendingMedicalSchedule?.length ? (
              <>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={id ? "0" : "1"}
                  onClick={() => customOnClick(1)}
                  className="pl-0"
                >
                  {`Outstanding Medical Checkups ( ${confirmMsg?.pendingMedicalSchedule?.length} )`}
                  <span style={{ float: "right" }}>
                    {id ? (
                      ""
                    ) : panelIndex === 1 ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={id ? "0" : "1"}>
                  <Card.Body>
                    <div className="table-responsive scrlHght">
                      <table className="table table-bordered">
                        <thead className="tableHead-bg">
                          <tr>
                            <th>Medical Test Type</th>
                            <th>Medical Status</th>
                            <th>SME Category</th>
                            <th>Due Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {confirmMsg?.pendingMedicalSchedule?.map((d, index) => (
                            <tr key={index}>
                              <td>{MEDICAL_TYPE_VIEW[d?.medicalTestType]}</td>
                              <td>{MEDICAL_STATUS_VIEW[d?.medicalStatus]}</td>
                              <td>
                                {d?.smeCategory
                                  ? EMPLOYEE_MEDICAL_CATEGORY[d?.smeCategory]
                                  : "Not available"}
                              </td>
                              <td>{DDMMYYYYFormat(d?.dueDate)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </>
            ) : (
              ""
            )}
            {confirmMsg?.pendingCapaData?.length ? (
              <>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={id ? "0" : "2"}
                  onClick={() => customOnClick(2)}
                  className="pl-0"
                >
                  {`Outstanding CAPAs ( ${confirmMsg?.pendingCapaData?.length} )`}
                  <span style={{ float: "right" }}>
                    {id ? (
                      ""
                    ) : panelIndex === 2 ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={id ? "0" : "2"}>
                  <Card.Body>
                    <div className="table-responsive scrlHght">
                      <table className="table table-bordered">
                        <thead className="tableHead-bg">
                          <tr>
                            <th>Capa Id</th>
                            <th>Source</th>
                            <th>Capa Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {confirmMsg?.pendingCapaData?.map((d, index) => (
                            <tr key={index}>
                              <td>{d?.capaId}</td>
                              <td>
                                {d?.source === "ehs_vfl_observations"
                                  ? "VFL"
                                  : "Incident Management"}
                              </td>
                              <td>
                                {d?.capaStatus === "OverDue" ? "Over Due" : d?.capaStatus}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </>
            ) : (
              ""
            )}
            {confirmMsg?.pendingMeetingTaskData?.length ? (
              <>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={id ? "0" : "3"}
                  onClick={() => customOnClick(3)}
                  className="pl-0"
                >
                  {`Outstanding OHSE Meeting Tasks ( ${confirmMsg?.pendingMeetingTaskData?.length} )`}
                  <span style={{ float: "right" }}>
                    {id ? (
                      ""
                    ) : panelIndex === 3 ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={id ? "0" : "3"}>
                  <Card.Body>
                    <div className="table-responsive scrlHght">
                      <table className="table table-bordered">
                        <thead className="tableHead-bg">
                          <tr>
                            <th>Task Id</th>
                            <th>Task Status</th>
                            <th>OHSE Review Id</th>
                          </tr>
                        </thead>
                        <tbody>
                          {confirmMsg?.pendingMeetingTaskData?.map((d, index) => (
                            <tr key={index}>
                              <td>{d?.task?.taskId}</td>
                              <td>{TASK_STATUS_VIEW[d?.task?.taskStatus]}</td>
                              <td>{d?.task?.ohseData?.scheduleId}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </>
            ) : (
              ""
            )}
            {confirmMsg?.pendingVflExecutiveData?.length ? (
              <>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={id ? "0" : "4"}
                  onClick={() => customOnClick(4)}
                  className="pl-0"
                >
                  {`Outstanding VFLs ( ${confirmMsg?.pendingVflExecutiveData?.length} )`}
                  <span style={{ float: "right" }}>
                    {id ? (
                      ""
                    ) : panelIndex === 4 ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={id ? "0" : "4"}>
                  <Card.Body>
                    <div className="table-responsive scrlHght">
                      <table className="table table-bordered">
                        <thead className="tableHead-bg">
                          <tr>
                            <th>VFL Id</th>
                            <th>VFL Status</th>
                            <th>VFL Assigned Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {confirmMsg?.pendingVflExecutiveData?.map((d, index) => (
                            <tr key={index}>
                              <td>{d?.vflId}</td>
                              <td>{VFL_STATUS_VIEW[d?.vflStatus]}</td>
                              <td>{DDMMYYYYFormat(d?.vflAssignedDate)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </>
            ) : (
              ""
            )}
            {confirmMsg?.pendingInvestigatorData?.length ? (
              <>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={id ? "0" : "5"}
                  onClick={() => customOnClick(5)}
                  className="pl-0"
                >
                  {`Outstanding Investigations ( ${confirmMsg?.pendingInvestigatorData?.length} )`}
                  <span style={{ float: "right" }}>
                    {id ? (
                      ""
                    ) : panelIndex === 5 ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={id ? "0" : "5"}>
                  <Card.Body>
                    <div className="table-responsive scrlHght">
                      <table className="table table-bordered">
                        <thead className="tableHead-bg">
                          <tr>
                            <th>Incident Id</th>
                            <th>Incident Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {confirmMsg?.pendingInvestigatorData?.map((d, index) => (
                            <tr key={index}>
                              <td>{d?.incidentDetails?.incidentId}</td>
                              <td>{d?.incidentDetails?.incidentStatus}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </>
            ) : (
              ""
            )}
            {confirmMsg?.pendingTrainingBatch?.length ? (
              <>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={id ? "0" : "6"}
                  onClick={() => customOnClick(6)}
                  className="pl-0"
                >
                  {`Outstanding Trainings ( ${confirmMsg?.pendingTrainingBatch?.length} )`}
                  <span style={{ float: "right" }}>
                    {id ? (
                      ""
                    ) : panelIndex === 6 ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={id ? "0" : "6"}>
                  <Card.Body>
                    <div className="table-responsive scrlHght">
                      <table className="table table-bordered">
                        <thead className="tableHead-bg">
                          <tr>
                            <th>Training Type</th>
                            <th>Batch Id</th>
                            <th>Training Status</th>
                            <th>Scheduled Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {confirmMsg?.pendingTrainingBatch?.map((d, index) => (
                            <tr key={index}>
                              <td>{TRAINING_TYPE_VIEW[d?.trainingType]}</td>
                              <td>{d?.batchData?.batchId}</td>
                              <td>{TRAINING_STATUS_VIEW[d?.trainingStatus]}</td>
                              <td>{DDMMYYYYFormat(d?.scheduledDate)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </>
            ) : (
              ""
            )}

            {confirmMsg?.assignedCapaOwnerData?.length ? (
              <>
                <div className="mb-1 mt-4 fs-3">
                  <div style={{ fontSize: "17px" }}>
                    <p className="mb-0">
                      This person is already an area owner at following mine and areas. If
                      you continue to change {type}, all CAPAs will be reverted back and
                      you need to re-assign CAPA area owner at originating location and
                      area.
                    </p>
                  </div>
                </div>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={id ? "0" : "7"}
                  onClick={() => customOnClick(7)}
                  className="pl-0 mb-2"
                >
                  {`Existing Areas ( ${confirmMsg?.assignedCapaOwnerData?.length} )`}
                  <span style={{ float: "right" }}>
                    {id ? (
                      ""
                    ) : panelIndex === 7 ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={id ? "0" : "7"}>
                  <Card.Body>
                    <div className="table-responsive scrlHght">
                      <table className="table table-bordered">
                        <thead className="tableHead-bg">
                          <tr>
                            <th>Location</th>
                            <th>Area Of Operation</th>
                          </tr>
                        </thead>
                        <tbody>
                          {confirmMsg?.assignedCapaOwnerData?.map((d, index) => (
                            <tr key={index}>
                              <td>{d?.sites?.name}</td>
                              <td>{d?.areaOfOperation?.name}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </>
            ) : (
              ""
            )}
          </Accordion>
        </>
      ) : (
        <>
          <div className="mb-4 fs-3">
            <div style={{ fontSize: "17px" }}>
              <p className="outstandingTxt">
                Following medical test is currently under progress by respective Medical
                Officer. You will not be able to change location unless it is completed.
                Medical Officer email id is:{" "}
                {confirmMsg?.pendingMedicalSchedule?.length
                  ? userDropdownLabel(
                      confirmMsg?.pendingMedicalSchedule[0]?.medicalOfficerData
                    )
                  : ""}
              </p>
            </div>
          </div>

          <Accordion defaultActiveKey={"1"} className="incidentDetailAcc">
            {confirmMsg?.pendingMedicalSchedule?.length ? (
              <>
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey={"1"}
                  onClick={() => customOnClick(1)}
                  className="pl-0"
                >
                  {`In Progress Medical Checkups ( ${confirmMsg?.pendingMedicalSchedule?.length} )`}
                  <span style={{ float: "right" }}>
                    {id ? (
                      ""
                    ) : panelIndex !== 1 ? (
                      <MdKeyboardArrowDown />
                    ) : (
                      <MdKeyboardArrowRight />
                    )}
                  </span>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey={"1"}>
                  <Card.Body>
                    <div className="table-responsive scrlHght">
                      <table className="table table-bordered">
                        <thead className="tableHead-bg">
                          <tr>
                            <th>Medical Test Type</th>
                            <th>Medical Status</th>
                            <th>SME Category</th>
                            <th>Due Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {confirmMsg?.pendingMedicalSchedule?.map((d, index) => (
                            <tr key={index}>
                              <td>{MEDICAL_TYPE_VIEW[d?.medicalTestType]}</td>
                              <td>{MEDICAL_STATUS_VIEW[d?.medicalStatus]}</td>
                              <td>
                                {d?.smeCategory
                                  ? EMPLOYEE_MEDICAL_CATEGORY[d?.smeCategory]
                                  : "Not available"}
                              </td>
                              <td>{DDMMYYYYFormat(d?.dueDate)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </>
            ) : (
              ""
            )}
          </Accordion>
        </>
      )}
    </div>
  );
};
